import React from 'react'
import { useTranslation } from '../../../services/static-text/hooks'
import { GIFT_PAYMENT_PAGE_STATIC_KEY } from './gift-payment-page-static-key'

export const PaymentEncryptionMessage = () => {
  const translateByKey = useTranslation(GIFT_PAYMENT_PAGE_STATIC_KEY)
  return (
    <div className="payment__encryption">
      <div className="payment__secure-lock-icon"></div>{' '}
      {translateByKey('securePaymentEncryption')}
    </div>
  )
}

export default PaymentEncryptionMessage
